import _ from '@lodash';
import 'ag-grid-enterprise';
import { useEffect, useState, useRef, useCallback } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useToast from '@fuse/hooks/useToast'
import { useDispatch, useSelector } from 'react-redux'
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomDropdownEditor from '@fuse/components/AgGridFilterGroupView/components/CustomDropdownEditor';
import { usePermission } from '@fuse/hooks';
import { customAlphanumericSort } from '@fuse/utils/aggridCustomSort';
import { handleFilterApplied, stripHtml } from 'helper/common';
import { quickAddedTicket } from '../store/reportViewDialogReducer';
import ActivityAgGridListing from '../activitiesAgGridListing';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import { openFormViewerDialog } from '../store/formViewDialogReducer';

function ListView(props) {
	const table_name = "SERVICE_REQUEST";
	const router = useRouter()
	const dispatch = useDispatch();
	// const rowGroupPanelShow = 'always';
	const toast = useToast(dispatch)
	const [gridApi, setGridApi] = useState(null);
	const gridRef = useRef();
	const [displayButton, setDisplayButton] = useState(false);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const tab_value = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.tab_value
	)
	const [filterApplied, setFilterApplied] = useState(false);
	const [modalData, setModalData] = useState(null);
	const [logs, setLogs] = useState([]);
	const [groupByArr, setGroupByArr] = useState([])
	const [tabValue, setTabValue] = useState(0)
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [isGridReady, setIsGridReady] = useState(0)
	const [filterData, setFilterData] = useState(JSON.parse(sessionStorage.getItem('redirectFilter')))
	const quick_added_ticket = useSelector(
		(state) => state.ServiceRequestsApp.reportViewDialogReducer.quickAddedTicket
	);
	const { hasPermission } = usePermission();
	const [filterText, setFilterText] = useState();
	const addServiceTicketPermission = hasPermission('add-service_request')

	const frameworkComponents = {
		customFilter: CustomFilter,
		customDropdownEditor: CustomDropdownEditor
	};
	const tableHeader = ["ticket_id", "serial_number", "status", "agent_name", "location", "subject_line", "detailed_description_of_the_issue", "created_date", "updated_date"]

	const handleClickOpen = (data) => {
		router.push(`/service-tickets/${data.id}`)
	}

	const handleArchive = (data) => {
		setModalData(data);
	};

	function handleClose() {
		setModalData(null);
	}

	const handleAddServiceTicket = () => {
		dispatch(openFormViewerDialog());
	}

	function handleConfirm() {
		axios.delete(`/service/archived-service-request/${modalData.id}`).then(() => {
			handleClose();
			refreshServiceRequestList()
			toast.success("Service Ticket archived Successfully.");
		}).catch((err) => {
			console.log("err", err.response);
		});
	}


	function flattenServiceRequest(data) {
		const serviceReqWithUnreadMessage = []; const serviceRequests = []
		for (const item of data) {
			const formattedObject = {
				id: item.service_request_table_id,
				ticket_id: item.ticket_id,
				subject_line: item.title,
				detailed_description_of_the_issue: stripHtml(item?.description),
				created_date: getLocalTimeFromUTC(item.created_at),
				updated_date: getLocalTimeFromUTC(item.updated_at),
				status: item.status_name,
				status_color: item.status_color,
				status_details: {
					id: item?.status_id,
					status_name: item?.status_name,
					status_color: item?.status_color
				},
				agent_name: item.agent_name,
				asset_id: item.asset_id,
				serial_number: item.serial_number,
				asset_name: item.asset_name,
				client_name: item.client_name,
				user_name: item.requestor_name,
				priority: item?.priority_name ?? '',
				priority_details: {
					id: item?.priority_id,
					priority_name: item?.priority_name ?? '',
					priority_color: item?.priority_color
				},
				location: item.location_name,
				has_unread_message: item.new_message_to_agent,
				childCount: item.childcount
			}
			if (formattedObject.has_unread_message) {
				serviceReqWithUnreadMessage.push(formattedObject)
			} else {
				serviceRequests.push(formattedObject)
			}
		}
		return [...serviceReqWithUnreadMessage, ...serviceRequests]
	}

	/** This function handles the fetching data from the server.
  It sends a POST request to the endpoint with parameters for server-side data retrieval.
  available property in params object
	{
	"startRow": 0,
	"endRow": 100,
	"rowGroupCols": [],
	"valueCols": [],
	"pivotCols": [],
	"pivotMode": false,
	"groupKeys": [],
	"filterModel": {},
	"sortModel": []
	}
  */
	function onFetchServiceRequest(params) {
		let url = '';
		url = `/service/show-all-service-request`
		// console.log(url)
		const { startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode } = params.request;
		axios.post(url, {
			dataSourceParams: {
				startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode
			}
		}).then((res) => {
			const rows = flattenServiceRequest(res.data.data.rows);
			const { lastRow } = res.data.data;
			(params.success || params.successCallback)?.({
				rowData: rows,
				rowCount: lastRow ?? rows.length,
			});
			if (rows.length === 0) gridRef.current.api.showNoRowsOverlay();
			else gridRef.current.api.hideOverlay();
		}).catch((err) => {
			console.log('error', err)
				(params.fail || params.failCallback)?.();
		})
	}

	const getChildCount = data => {
		// here child count is stored in the 'childCount' property
		return data.childCount;
	};

	/** This object represents the data source for the grid.
	*It defines a `getRows` function that is invoked by the grid to fetch rows from the server.
	*/
	const datasource = {
		getRows(params) {
			// Call the function to fetch asset data from the server.
			onFetchServiceRequest(params)
		}
	};

	/** This useCallback function, when invoked, refreshes the list in the grid.
	*It checks if the grid API is available before attempting to refresh.
	*/
	const refreshServiceRequestList = useCallback(() => {
		if (!gridRef.current) return
		if (gridRef.current?.api?.refreshServerSideStore) {
			gridRef.current.api.refreshServerSideStore({ purge: false });
		} else if (gridRef.current?.api?.refreshServerSide) {
			gridRef.current.api.refreshServerSide();
		}
	}, [gridRef]);

	const onGridReady = (params) => {
		gridRef.current = params;
		setIsGridReady(isGridReady + 1)
		setGridApi(params);
		if (router.query.report_name === undefined) {
			// params?.api.setGridOption('serverSideDatasource', datasource);
			loadInitialState(params)
			dispatch(setfilterlist({}));
			// dispatch(setrowGroupModel([]));
		} else {
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}

	function loadInitialState(params) {
		axios
			.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then((results) => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current.filterModelArr = filter;
					params?.api?.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (Object.keys(filter ?? {})?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch((err) => {
				console.log(err);
			}).finally(() => {
				const dataSource = {
					getRows: async (param) => {
						onFetchServiceRequest(param)
					}
				}
				params?.api.setGridOption('serverSideDatasource', dataSource);
			});
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		// stop rerender to show no overlay text
		gridRef.current = {...gridRef.current,filterModelArr:rows}
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
	}

	function getReport(event) {
		const { report_name } = router.query;
		const table_name = "service request";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const row_model = JSON.parse(results.data.data.row_model);
				event?.api.applyColumnState({ state: row_model });
			})
			// autoGroupColumnDef={{ minWidth: 5000 }}
			.catch(err => {
				console.log(err);
			})
	}


	useEffect(() => {
		if (filterApplied) {
			toast.success("Filters have been applied")
		}
	}, [filterApplied])

	function onSortChanged(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows));
			saveView(rows);
		}
	}

	function saveView(rows, filter, filterModelArr = null) {
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	const onColumnMoved = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	function onColumnVisible(params) {
		const rows = params.api.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name === undefined) {
				saveView(rows);
			}
		}
	}

	// function onColumnRowGroupChanged(event) {
	// 	if (event.columns.length === 0) {
	// 		setGroupByArr([])
	// 	} else {
	// 		setGroupByArr(event.columns)
	// 	}
	// }

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);

		if (router.query.report_name === undefined) {
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setrowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
				// saveView(rows);
			}
		}
	}

	const onRangeSelectionChanged = (params) => {
		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	function cellRendererFrameworkFramework(params) {
		if (params.column.colId === "serial_number") {
			if (params.value === "No Serial Number") return (<span>{params.value}</span>)
			return (<a
				style={{
					height: '10px',
					width: '10px',
					color: 'black',
					cursor: 'pointer',
					marginTop: '2px',
					borderRadius: '50%',
					display: 'inline-block',
				}}
				onClick={() => redirectToAssetProfile(params)}
				variant="subtitle1"
			>
				<span>{params.value}</span>
			</a>)
		}
		if (params.column.colId === "ticket_id") {
			return (
				<div style={{
					display: 'flex',
					alignItems: 'center',
					gap: '10px'
				}}>
					<div
						style={{
							height: '10px',
							backgroundColor: params?.data?.has_unread_message ? 'red' : 'transparent',
							width: '10px',
							borderRadius: '50%'
						}}
					/>
					<span>{params.value}</span>
				</div>
			)
		}
		return <span>{params.value}</span>
	}

	const generateHeaderLabel = (header) => {
		if (header === 'accessory_category_id') {
			return 'Accessory Category Name'
		} if (header === 'manufacturer_id') {
			return 'Manufacturer Name'
		} if (header === 'detailed_description_of_the_issue') {
			return 'Issue Description'
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	useEffect(() => {
		gridRef?.current?.api?.setQuickFilter(query_data);
	}, [query_data])

	useEffect(() => {
		// onGridReady()
		return () => {
			dispatch(setQuickFilter(null))
		}
	}, [props.serviceRequests])

	const handleChildClick = (value) => {
		setTabValue(value)
	};

	useEffect(() => {
		setTabValue(tab_value)
	}, [tab_value])

	function redirectToAssetProfile(event) {
		router.push(`/${event.data.archived_asset ? 'archived-assets' : 'assets-list'}/${event.data.asset_id}`);
	}

	function handleHideColumnDropDownDesign() {
		if (!groupByArr.length) {
			return {
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "space-between",
				border: "1px solid #000000",
				borderRadius: "20px",
				padding: "3px 10px",
				backgroundColor: "#ffffff",
				lineHeight: "1",
				height: "28px",
				position: "relative",
				cursor: "pointer",
				fontFamily: '"Inter", sans-serif',
				fontSize: "13px",
				fontWeight: 500,
			};
		}
		return {}
	}


	useEffect(() => {
		if (quick_added_ticket) {
			refreshServiceRequestList()
			dispatch(quickAddedTicket())
		}
	}, [quick_added_ticket])

	/** Add refreshServiceRequestList function as an Event Listener
	 * to call it from Layout file or from any other places.
	 */
	useEffect(() => {
		setTimeout(() => {
			window.addEventListener("refreshServiceRequestList", refreshServiceRequestList);
		}, 0)

		return () => {
			window.removeEventListener("refreshServiceRequestList", refreshServiceRequestList);
		};
	}, [refreshServiceRequestList]);

	 useEffect(() => {
		 setTimeout(() => {
		   const filterArray = filterData;
		   if (filterArray && gridRef.current.api) {
			 console.log('filterArray', filterArray, gridRef.current?.api)
			 sessionStorage.removeItem("redirectFilter")
			 handleFilterApplied(filterArray, gridRef.current?.api);
			   setFilterData()
			    if (Object.keys(filterArray?.filterModel)?.length) {
					setFilterApplied(true)
					setFilterText('User is currently viewing the Service ticket page with the following filters…');
				}
		   }
		 }, 1000)
	  }, [gridRef.current?.api])

	return (
		<>
			{(tabValue === 0) && <AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="service_request"
				logs={logs}
				displayTableName="Service Tickets"
				onClick={handleChildClick}
				onClickAddButton={handleAddServiceTicket}
				addPermission={addServiceTicketPermission}
				key={isGridReady}
				clearRedirectionFilter={() => {
					setFilterApplied(false)
					setFilterText()
				}}
			/>}
			{(tabValue === 1) && (<ActivityAgGridListing module="service_request" logs={logs} displayTableName="Service Tickets" />)}

			{
				(tabValue === 0) &&
				<div
					className="ag-theme-alpine"
					style={{
						width: "100%",
						height: windowHeight + 105,
						fontSize: '11px'
					}}
				>
						{filterApplied && <p style={{ margin: '4px' }}>{filterText || 'Filters have been applied'}</p>}
					<AgGridReact
						rowModelType='serverSide'
						serverSideStoreType="partial"
						ref={gridRef}
						theme="legacy"
						suppressRowClickSelection
						onGridReady={onGridReady}
						animateRows
						// rowData={props.serviceRequests}
						rowHeight={35}
						headerHeight={44}
						onRowClicked={() => {
						}}
						// Set the desired sheet name
						defaultExcelExportParams={{
							sheetName: 'Dalos-Source'
						}}
						defaultColDef={{
							enableRowGroup: true,
							resizable: true,
							suppressMenu: true,
						}}
						// no rows overlay 
						overlayNoRowsTemplate="<span>No Result Found</span>"
						// Row Grouping conditions
						showOpenedGroup
						suppressDragLeaveHidesColumns
						suppressMakeColumnVisibleAfterUnGroup
						rowGroupPanelShow={rowGroupPanelShow}

						onColumnMoved={onColumnMoved}
						onColumnPinned={onColumnPinned}
						onColumnVisible={onColumnVisible}
						onSortChanged={onSortChanged}
						groupHeaderHeight={1}
						// headerHeight = {15}
						floatingFiltersHeight={40}

						// status bar enabled on range selection
						enableRangeSelection
						statusBar={{
							statusPanels: [
								{
									statusPanel: 'agAggregationComponent'
								},
							],
						}}

						// to check the the no. of rows selected during range selection
						onRangeSelectionChanged={onRangeSelectionChanged}

						onFilterChanged={onFilterChanged}

						// on column group changed
						onColumnRowGroupChanged={onColumnRowGroupChanged}
						components={frameworkComponents}
						pagination
						getChildCount={getChildCount}
						columnDefs={[
							{
								lockPosition: true,
								rowSelection: "single",
								width: 120,
								minWidth: 120,
								maxWidth: 120,
								suppressSizeToFit: true,
								headerName: "Actions",
								suppressMenu: true,
								suppressHeaderMenuButton: true,
								sortable: false,
								pinned: 'right',
								className: "action_field",
								lockPinned: true,
								cellRenderer: ({ data }) => {
									if (data) {
										return (
											<>
												{props.viewServiceRequestPermission && <Tooltip id="view" title="View" placement="top">
													{/* <Icon onClick={() => handleClickOpen(data)} fontSize='small' style={{ color: '#1d2939', paddingBottom: '3px', paddingRight: '30px', fontSize: '15px', cursor: 'pointer' }} >visibility</Icon> */}
													<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-eye" onClick={() => handleClickOpen(data)} />
												</Tooltip>}
												{props.deleteServiceRequestPermission && <Tooltip id="delete" title="Archive" placement="top">
													{/* <Icon onClick={() => { handleArchive(data) }} style={{ color: '#1d2939', paddingBottom: '3px', paddingRight: '30px', fontSize: '15px', cursor: 'pointer' }}>archive</Icon> */}
													<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-archive" onClick={() => handleArchive(data)} />
												</Tooltip>}
											</>
										)
									}
									return (<></>)

								}
							},
							...tableHeader.map(header => {
								if (header === 'status') {
									return {
										field: header,
										key: header,
										minWidth: 230,
										cellEditorPopup: true,
										suppressSizeToFit: true,
										// cellEditor="agRichSelectCellEditor"
										cellEditor: 'customDropdownEditor',
										headerComponent: (prop) => (CustomFilter(prop, header, gridRef)),
										sortable: true,

										// floatingFilter
										headerName: generateHeaderLabel(header),
										filter: "agTextColumnFilter",
										editable: false,
										cellRenderer: (event) => {
											if (event.colDef.field === "status") {
												return (
													<span
														style={handleHideColumnDropDownDesign()}>
														<span
															style={{
																height: "10px",
																width: "10px",
																marginTop: "2px",
																borderRadius: "50%",
																display: "inline-block",
																// backgroundColor: event.data?.asset_status_color?.code
																backgroundColor:
																	event.value?.split(",")[1] ??
																	event.data?.status_details?.status_color?.code,
															}}
														/>
														{/* <span style={{height: '10px',width: '10px',backgroundColor: '#bbb',borderRadius: '50%',display:'inline-block'}}></span> */}
														{/* <span style={{marginLeft: '5px'}}>{event.data?.status_value?.status_name}</span> */}
														<span style={{ marginLeft: "5px", marginRight: '14px', fontSize: '12px', fontWeight: '500', color: 'black', fontFamily: '"Inter", sans-serif', }}>
															{event.value?.split(",")[0]}
														</span>
													</span>
												);
											} if (
												event.colDef.headerName === "Group" &&
												event.node.field === "status"
											) {
												return (
													<>
														<span>{event.value}</span>
													</>
												);
											}
											return (
												<>
													<span>{event.value}</span>
												</>
											);

										}
									}
								}
								if (header === 'detailed_description_of_the_issue') {
									return {
										field: header,
										key: header,
										suppressSizeToFit: true,
										headerName: generateHeaderLabel(header),
										sortable: true,
										minWidth: 400,
										flex: 1,
										headerComponent: (props) => (CustomFilter(props, header, gridRef)),
										filter: "text"
									}
								}
								if (header === 'ticket_id') {
									return {
										field: header,
										key: header,
										suppressSizeToFit: true,
										headerName: generateHeaderLabel(header),
										sortable: true,
										minWidth: 200,
										flex: 1,
										headerComponent: (props) => (CustomFilter(props, header, gridRef)),
										filter: "agTextColumnFilter",
										comparator: customAlphanumericSort,
										cellRenderer: cellRendererFrameworkFramework,
									}
								}
								return {
									field: header,
									key: header,
									suppressSizeToFit: true,
									headerName: generateHeaderLabel(header),
									sortable: true,
									minWidth: 200,
									flex: 1,
									headerComponent: (props) => (CustomFilter(props, header, gridRef)),
									filter: "agTextColumnFilter",
									cellRenderer: cellRendererFrameworkFramework,
								}
							})
						]}
					/>
				</div>
			}

			{modalData && (
				<GeneralModal
					open={Boolean(modalData)}
					title="Are you sure to archive service ticket?"
					text={
						<h4>
							Are you sure to Archive this Service Ticket?
							{/* <b>{modalData.ticket_number}</b>? */}
						</h4>
					}
					detailMessage="Your ticket will be moved to archive service tickets if you proceed"
					handleClose={handleClose}
					handleConfirm={handleConfirm}
					actionButtonName="Yes, Proceed!"
				/>
			)}
		</>
	);
}

export default ListView